import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { USER_PERSIST_WHITELIST, UserReducer } from "./Apps/users/userSlice";
import { DashboardReducer } from "./Apps/Lawyerapp/DashboardSlice/DashboardSlice";
import { CustomFieldReducer } from "./Apps/Lawyerapp/CustomFieldSlice";
import { TaskSliceReducer } from "./Apps/Lawyerapp/TaskSlice/TaskSlice";
import { CaseReducer } from "./Apps/Lawyerapp/CaseSlice/CaseSlice";
import { contactReducer } from "./Apps/Lawyerapp/ContactSlice/ContactSlice";
import { AccountReducer } from "./Apps/Lawyerapp/AccountSlice/AccountSlice";
import { ActivityReducer } from "./Apps/Lawyerapp/ActivitySlice/ActivitySlice";
import { BillingReducer } from "./Apps/Lawyerapp/BillingSlice/BillingSlice";
import { DocumentSliceReducer } from "./Apps/Lawyerapp/DocumentSlice/DocumentSlice";

const userPersistConfig = {
  key: "user",
  storage,
  whitelist: USER_PERSIST_WHITELIST,
};

const appReducer = combineReducers({
  user: persistReducer(userPersistConfig, UserReducer),
  dashboard: DashboardReducer,
  contact: contactReducer,
  customField: CustomFieldReducer,
  task: TaskSliceReducer,
  case: CaseReducer,
  account: AccountReducer,
  activity: ActivityReducer,
  billing: BillingReducer,
  document: DocumentSliceReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "user/logout") {
    storage.removeItem("persist:root");
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export default rootReducer;
